export default __webpack_public_path__ + "static/media/white-logo.f7a760cb.png";